import { CalendarPlus, Download } from "lucide-react";
import { API } from "@/lib/api";

function pad(n) {
  return String(n).padStart(2, "0");
}

function googleUrl(booking, minutes) {
  const start = new Date(`${booking.scheduled_date}T${booking.scheduled_time}:00`);
  const end = new Date(start.getTime() + minutes * 60000);
  const f = (d) => `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}00`;
  const p = new URLSearchParams({
    action: "TEMPLATE",
    text: `CJ's Mobile Detailing — ${booking.service_name}`,
    dates: `${f(start)}/${f(end)}`,
    details: `Ref ${booking.id}. Vehicle: ${booking.vehicle.year} ${booking.vehicle.make} ${booking.vehicle.model}.`,
    location: booking.customer.address,
    ctz: "Australia/Melbourne",
  });
  return `https://calendar.google.com/calendar/render?${p}`;
}

export default function AddToCalendar({ booking, minutes = 120 }) {
  const ics = `${API}/bookings/${booking.id}/calendar.ics`;
  return (
    <div className="cj-card p-5" data-testid="add-to-calendar">
      <div className="flex items-center gap-2">
        <CalendarPlus className="h-4 w-4 text-[#ff6b00]" />
        <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#ff6b00]">Add to your calendar</div>
      </div>
      <p className="text-xs text-slate-400 mt-2">Get a reminder on your phone — pick your calendar app.</p>
      <div className="mt-3 grid grid-cols-1 sm:grid-cols-3 gap-2">
        <a href={googleUrl(booking, minutes)} target="_blank" rel="noreferrer" data-testid="calendar-google-link" className="cj-btn-ghost px-3 py-2.5 rounded-lg text-xs text-center font-display uppercase font-bold tracking-wider">
          Google
        </a>
        <a href={ics} data-testid="calendar-apple-link" className="cj-btn-ghost px-3 py-2.5 rounded-lg text-xs text-center font-display uppercase font-bold tracking-wider">
          Apple / iPhone
        </a>
        <a href={ics} data-testid="calendar-ics-link" className="cj-btn-ghost px-3 py-2.5 rounded-lg text-xs text-center font-display uppercase font-bold tracking-wider inline-flex items-center justify-center gap-1">
          <Download className="h-3 w-3" /> Outlook (.ics)
        </a>
      </div>
    </div>
  );
}
